import React, { useEffect, useState } from "react";
import SubscriberCard from "./SubscriberCard";
import axios from "axios";
import ReceiptsTable from "./ReceiptsTable";

const SubscriberView = ({ currentRecord }) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const getDataFromServer = () => {
      let userToken = localStorage.getItem("token");
      let urlLink = `${process.env.REACT_APP_API_URL}/receipt/${currentRecord?.subscriber_id?._id}`;
      const config = {
        method: "GET",
        url: urlLink,
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      };
      axios(config)
        .then(function (response) {
          //console.log(JSON.stringify(response.data.users));
          const oldData = response.data.receipts;
          const updatedData = oldData.map((data) => {
            return {
              ...data,
              id: data?._id,
            };
          });

          setData(updatedData);
          //console.log(updatedData);
        })
        .catch(function (err) {
          console.log("error api call ", err);
        });
    };

    getDataFromServer();
  }, []);
  return (
    <div className="flex flex-col items-center p-5 ">
      <SubscriberCard data={currentRecord} rdata={data} />
      {/* <ReceiptsTable data={data} /> */}
    </div>
  );
};

export default SubscriberView;
